import React from 'react'
import PropTypes from 'prop-types'
import Navbar from 'containers/Navbar'
import classes from './CoreLayout.scss'
import { Notifications } from 'modules/notification'
import 'styles/core.scss'
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles';
import indigo from 'material-ui/colors/indigo';
import pink from 'material-ui/colors/pink';
import red from 'material-ui/colors/red';
import amber from 'material-ui/colors/amber';
import orange from 'material-ui/colors/orange';

const theme = createMuiTheme({
  palette: {
    primary: amber,
    secondary: orange,
    error: red,
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
});

export const CoreLayout = ({ children, location }) => (
  <MuiThemeProvider theme={theme}>
  <div className={classes.container}>
  { location
      .pathname
  .split('/')[1] == 'testcc' ? <div></div> : <Navbar /> }
    <div className={ location.pathname.split('/')[1] == 'testcc' ? classes.headerlesschildren : classes.children}>
    {children}</div>
    <Notifications />
  </div>
  </MuiThemeProvider>
)

CoreLayout.propTypes = {
  children: PropTypes.element.isRequired
}

export default CoreLayout



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/CoreLayout.js